module.exports = __webpack_public_path__ + "vue/img/xz.5a8707cd.png";